/*
 * Курс «Русский язык: подготовка к ЕГЭ и ОГЭ» — доменные шаги.
 *
 *   stress-pick  — ударение по ОФИЦИАЛЬНОМУ списку ФИПИ через EgeStressCore
 *                  (/udareniya-ege): карточки «нажми ударную гласную» или
 *                  задание 4 в формате экзамена. Список грузится один раз.
 *   letter-gap   — пропуск в слове внутри фразы: буква, слитно/раздельно,
 *                  Н/НН; поштучный разбор с правилом.
 *   punct-place  — предложение с цифрами на местах запятых (задания 17–20 ЕГЭ,
 *                  5 ОГЭ): нажатием ставят и снимают запятую.
 *   text-means   — пронумерованный текст, отметить предложения по условию.
 *   essay-check  — оценить сочинение по официальным критериям и сравнить
 *                  с баллами эксперта.
 *   mock-part    — блок заданий в формате бланка, на время, по ключу ФИПИ.
 *
 * Данные шагов — course.json, тексты — text/ru.json, подписи интерфейса —
 * `ui` в resources/lang/ru/tools/russian-exam-course.php. Разбор —
 * docs/why/russian-exam-course.md.
 */
(function () {
    'use strict';
    var K = window.CourseKit;
    if (!K) return;
    var CFG = window.__RU_EXAM || {};

    function T(step) { return step.t || {}; }

    /* Слово ответа так, как его сверяет бланк: без регистра, ё = е, без
       пробелов и знаков (в бланке их нет). Дефис остаётся частью слова. */
    function normWord(s) {
        return String(s == null ? '' : s).toLowerCase().replace(/ё/g, 'е')
            .replace(/[\s,.;:!?«»"'()]/g, '');
    }
    function digitsOf(s) {
        return String(s == null ? '' : s).replace(/[^0-9]/g, '');
    }
    function sortedSet(s) {
        var out = [];
        digitsOf(s).split('').forEach(function (c) { if (out.indexOf(c) < 0) out.push(c); });
        return out.sort().join('');
    }

    /* ── список ФИПИ (задание 4) ──────────────────────────────────────── */
    var listP = null;
    function loadList() {
        if (listP) return listP;
        if (!window.EgeStressCore || !CFG.orthoepyUrl) return Promise.reject(new Error('no_core'));
        listP = fetch(CFG.orthoepyUrl, { credentials: 'same-origin' })
            .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
            .then(function (data) { return window.EgeStressCore.items(data); });
        listP.catch(function () { listP = null; });
        return listP;
    }

    K.step('stress-pick', {
        graded: true,
        mount: function (host, step, api) {
            var t = T(step);
            if (t.prompt) host.appendChild(api.richEl('p', 'crs-prompt', t.prompt));
            var box = api.el('div', 'rx-stress');
            host.appendChild(box);
            box.appendChild(api.el('p', 'crs-hint', api.tt('stress_loading')));
            var core = window.EgeStressCore;
            loadList().then(function (all) {
                if (!api.alive()) return;
                var secs = step.sections || null;
                var list = secs ? all.filter(function (it) { return secs.indexOf(it.section) >= 0; }) : all;
                box.innerHTML = '';
                if ((step.mode || 'cards') === 'task4') task4(list); else cards(list);
            }, function () {
                if (!api.alive()) return;
                box.innerHTML = '';
                api.skip(api.tt('stress_unavailable'));
            });

            function cards(list) {
                var n = Math.min(step.n || 8, list.length);
                var deck = api.shuffle(list).slice(0, n);
                var i = 0, right = 0, misses = [];
                var count = api.el('p', 'crs-hint');
                var word = api.el('div', 'rx-word');
                word.setAttribute('role', 'group');
                var hint = api.el('p', 'rx-line');
                box.appendChild(count); box.appendChild(word); box.appendChild(hint);
                function show() {
                    var it = deck[i];
                    count.textContent = api.tt('stress_count', { n: i + 1, total: n });
                    hint.textContent = '';
                    word.innerHTML = '';
                    word.setAttribute('aria-label', api.tt('stress_card_aria'));
                    var b = core.bare(it), slots = core.vowelSlots(it), slotOrd = {};
                    slots.forEach(function (pos, k) { slotOrd[pos] = k; });
                    for (var p = 0; p < b.length; p++) {
                        if (slotOrd.hasOwnProperty(p)) {
                            var btn = api.el('button', 'rx-v', b[p]);
                            btn.type = 'button';
                            btn.setAttribute('data-ord', slotOrd[p]);
                            btn.addEventListener('click', pick);
                            word.appendChild(btn);
                        } else {
                            word.appendChild(api.el('span', 'rx-c', b[p]));
                        }
                    }
                }
                function pick(e) {
                    var it = deck[i];
                    var ord = +e.currentTarget.getAttribute('data-ord');
                    var ok = ord === it.ord || it.alt.indexOf(ord) >= 0;
                    var btns = word.querySelectorAll('.rx-v');
                    for (var k = 0; k < btns.length; k++) {
                        btns[k].disabled = true;
                        var o = +btns[k].getAttribute('data-ord');
                        if (o === it.ord) btns[k].classList.add('is-right');
                        else if (o === ord) btns[k].classList.add('is-wrong');
                    }
                    if (ok) right++; else misses.push(core.shown(it, it.ord));
                    hint.textContent = it.line;
                    api.announce(ok ? api.t('fb_right') : api.t('fb_wrong'));
                    setTimeout(function () {
                        if (!api.alive()) return;
                        i++;
                        if (i < n) show();
                        else api.answer({ correct: right / n >= (step.pass || 0.8) - 1e-9, score: n ? right / n : 1,
                            reveal: misses.length ? misses.join(', ') : null,
                            explain: api.tt('stress_score', { n: right, total: n }) + (t.explain ? '\n\n' + t.explain : '') });
                    }, ok ? 900 : 2200);
                }
                show();
            }

            function task4(list) {
                var rounds = step.rounds || 1, r = 0, points = 0, reveals = [];
                var area = api.el('div', 'rx-task4');
                box.appendChild(area);
                function round() {
                    area.innerHTML = '';
                    var task = core.examTask(list, Math.random);
                    if (rounds > 1) area.appendChild(api.el('p', 'crs-hint', api.tt('stress_round', { n: r + 1, total: rounds })));
                    area.appendChild(api.el('p', 'crs-hint', api.tt('stress_task_hint')));
                    var picked = {};
                    var opts = api.el('div', 'crs-opts');
                    var btns = task.words.map(function (w, k) {
                        var b = api.el('button', 'crs-opt');
                        b.type = 'button';
                        b.setAttribute('aria-pressed', 'false');
                        b.appendChild(api.el('span', 'crs-opt-n', String(k + 1)));
                        b.appendChild(api.el('span', 'rx-w4', w.text));
                        b.addEventListener('click', function () {
                            if (b.disabled) return;
                            picked[k] = !picked[k];
                            b.classList.toggle('is-picked', !!picked[k]);
                            b.setAttribute('aria-pressed', picked[k] ? 'true' : 'false');
                        });
                        opts.appendChild(b);
                        return b;
                    });
                    area.appendChild(opts);
                    var ans = api.el('p', 'rx-ans');
                    area.appendChild(ans);
                    api.primary(api.t('check'), function () {
                        var sel = Object.keys(picked).filter(function (k) { return picked[k]; }).map(function (k) { return +k + 1; });
                        var res = core.checkExam(task, sel);
                        points += res.point;
                        btns.forEach(function (b, k) {
                            b.disabled = true;
                            b.classList.add(task.words[k].right ? 'is-right' : (picked[k] ? 'is-wrong' : 'rx-dim'));
                        });
                        var keyTx = api.tt('stress_key', { key: res.answer || '—', given: res.given || '—' });
                        ans.textContent = keyTx + ' · ' + task.words.map(function (w) { return core.shown(w.item, w.item.ord); }).join(', ');
                        if (!res.point) reveals.push(res.answer || '—');
                        r++;
                        if (r < rounds) {
                            api.primary(api.t('next'), round);
                        } else {
                            api.answer({ correct: points / rounds >= (step.pass || 0.5) - 1e-9, score: points / rounds,
                                explain: api.tt('stress_points', { n: points, total: rounds }) + (t.explain ? '\n\n' + t.explain : '') });
                        }
                    });
                }
                round();
            }
        }
    });

    /* ── пропуск в слове ──────────────────────────────────────────────── */
    K.step('letter-gap', {
        graded: true,
        mount: function (host, step, api) {
            var t = T(step);
            var items = t.items || [];
            var answers = step.answers || [];
            if (t.prompt) host.appendChild(api.richEl('p', 'crs-prompt', t.prompt));
            var list = api.el('div', 'rx-gaps');
            host.appendChild(list);
            var chosen = items.map(function () { return -1; });
            var rows = items.map(function (it, i) {
                var row = api.el('div', 'rx-gap');
                var line = api.el('p', 'rx-gap-tx');
                var parts = String(it.t).split('{}');
                var slot = api.el('span', 'rx-slot', '…');
                line.appendChild(document.createTextNode(parts[0] || ''));
                line.appendChild(slot);
                line.appendChild(document.createTextNode(parts.slice(1).join('{}')));
                row.appendChild(line);
                var chips = api.el('div', 'crs-chips');
                var opts = it.o || [];
                var order = opts.map(function (_, k) { return k; });
                var btns = [];
                order.forEach(function (k) {
                    var c = api.el('button', 'crs-chip', opts[k]);
                    c.type = 'button';
                    c.setAttribute('aria-pressed', 'false');
                    c.addEventListener('click', function () {
                        if (c.disabled) return;
                        chosen[i] = k;
                        btns.forEach(function (x) { x.classList.remove('is-sel'); x.setAttribute('aria-pressed', 'false'); });
                        c.classList.add('is-sel');
                        c.setAttribute('aria-pressed', 'true');
                        slot.textContent = opts[k];
                        slot.classList.add('is-set');
                        api.primaryEnabled(chosen.every(function (x) { return x >= 0; }));
                    });
                    btns.push(c);
                    chips.appendChild(c);
                });
                row.appendChild(chips);
                var why = api.el('p', 'rx-why');
                why.hidden = true;
                row.appendChild(why);
                list.appendChild(row);
                return { row: row, slot: slot, btns: btns, why: why };
            });
            api.primary(api.t('check'), function () {
                var right = 0, wrong = [];
                items.forEach(function (it, i) {
                    var ok = chosen[i] === answers[i];
                    var r = rows[i];
                    r.btns.forEach(function (b) { b.disabled = true; });
                    r.row.classList.add(ok ? 'is-right' : 'is-wrong');
                    r.slot.textContent = (it.o || [])[answers[i]];
                    if (ok) right++; else wrong.push(String(it.t).replace('{}', (it.o || [])[answers[i]]));
                    if (it.why) { r.why.innerHTML = api.rich((ok ? '✓ ' : '✗ ') + it.why); r.why.hidden = false; }
                });
                api.answer({ correct: right === items.length, score: items.length ? right / items.length : 1,
                    reveal: wrong.length ? wrong.join('\n') : null });
            }, true);
        }
    });

    /* ── запятые по цифрам ────────────────────────────────────────────── */
    K.step('punct-place', {
        graded: true,
        mount: function (host, step, api) {
            var t = T(step);
            var need = (step.commas || []).map(Number);
            if (t.prompt) host.appendChild(api.richEl('p', 'crs-prompt', t.prompt));
            host.appendChild(api.el('p', 'crs-hint', api.tt('punct_hint')));
            var p = api.el('p', 'rx-sent');
            host.appendChild(p);
            var gaps = {};
            var re = /\((\d+)\)/g, last = 0, m, src = String(t.sentence || '');
            while ((m = re.exec(src))) {
                if (m.index > last) p.appendChild(document.createTextNode(src.slice(last, m.index).replace(/\s+$/, '')));
                var n = +m[1];
                var b = api.el('button', 'rx-gp');
                b.type = 'button';
                b.setAttribute('aria-pressed', 'false');
                b.setAttribute('aria-label', api.tt('punct_gap', { n: n }));
                b.appendChild(api.el('span', 'rx-gp-mark', ''));
                b.appendChild(api.el('sup', 'rx-gp-n', String(n)));
                (function (btn, num) {
                    btn.addEventListener('click', function () {
                        if (btn.disabled) return;
                        gaps[num].on = !gaps[num].on;
                        btn.classList.toggle('is-on', gaps[num].on);
                        btn.setAttribute('aria-pressed', gaps[num].on ? 'true' : 'false');
                        btn.firstChild.textContent = gaps[num].on ? ',' : '';
                    });
                })(b, n);
                gaps[n] = { btn: b, on: false };
                p.appendChild(b);
                p.appendChild(document.createTextNode(' '));
                last = re.lastIndex;
                while (src[last] === ' ') last++;
            }
            if (last < src.length) p.appendChild(document.createTextNode(src.slice(last)));
            var whyBox = api.el('ul', 'rx-whys');
            host.appendChild(whyBox);
            api.primary(api.t('check'), function () {
                var nums = Object.keys(gaps).map(Number).sort(function (a, b) { return a - b; });
                var right = 0;
                nums.forEach(function (n) {
                    var g = gaps[n], should = need.indexOf(n) >= 0, ok = g.on === should;
                    if (ok) right++;
                    g.btn.disabled = true;
                    g.btn.classList.add(ok ? 'is-right' : 'is-wrong');
                    g.btn.firstChild.textContent = should ? ',' : '';
                    var w = t.why && t.why[String(n)];
                    if (w && (!ok || step.whyAll)) whyBox.appendChild(api.richEl('li', null, '(' + n + ') ' + w));
                });
                var key = need.slice().sort(function (a, b) { return a - b; }).join('');
                api.answer({ correct: right === nums.length, score: nums.length ? right / nums.length : 1,
                    reveal: right === nums.length ? null : api.tt('punct_key', { key: key || '—' }) });
            });
        }
    });

    /* ── предложения текста ───────────────────────────────────────────── */
    K.step('text-means', {
        graded: true,
        mount: function (host, step, api) {
            var t = T(step);
            var start = step.start || 1;
            var answer = (step.answer || []).map(Number);
            if (t.prompt) host.appendChild(api.richEl('p', 'crs-prompt', t.prompt));
            host.appendChild(api.el('p', 'crs-hint', api.tt('text_hint')));
            var box = api.el('div', 'rx-text');
            host.appendChild(box);
            var picked = {}, btns = {};
            (t.sentences || []).forEach(function (s, k) {
                var n = start + k;
                var b = api.el('button', 'rx-sn');
                b.type = 'button';
                b.setAttribute('aria-pressed', 'false');
                b.appendChild(api.el('b', null, '(' + n + ')'));
                b.appendChild(document.createTextNode(' ' + s));
                b.addEventListener('click', function () {
                    if (b.disabled) return;
                    picked[n] = !picked[n];
                    b.classList.toggle('is-picked', !!picked[n]);
                    b.setAttribute('aria-pressed', picked[n] ? 'true' : 'false');
                    api.primaryEnabled(Object.keys(picked).some(function (x) { return picked[x]; }));
                });
                btns[n] = b;
                box.appendChild(b);
            });
            api.primary(api.t('check'), function () {
                var sel = Object.keys(picked).filter(function (x) { return picked[x]; }).map(Number);
                var hit = sel.filter(function (n) { return answer.indexOf(n) >= 0; }).length;
                var bad = sel.length - hit;
                Object.keys(btns).forEach(function (k) {
                    var n = +k, b = btns[n];
                    b.disabled = true;
                    if (answer.indexOf(n) >= 0) b.classList.add('is-right');
                    else if (picked[n]) b.classList.add('is-wrong');
                });
                var ok = hit === answer.length && bad === 0;
                api.answer({ correct: ok, score: ok ? 1 : Math.max(0, (hit - bad) / Math.max(1, answer.length)),
                    reveal: ok ? null : answer.join(', ') });
            }, true);
        }
    });

    /* ── сочинение по критериям ───────────────────────────────────────── */
    K.step('essay-check', {
        graded: true,
        reviewable: false,
        mount: function (host, step, api) {
            var t = T(step);
            var crit = step.criteria || [];
            var expert = step.scores || {};
            if (t.prompt) host.appendChild(api.richEl('p', 'crs-prompt', t.prompt));
            if (t.topic) host.appendChild(api.richEl('p', 'rx-topic', t.topic));
            var essay = api.el('div', 'rx-essay');
            (t.essay || []).forEach(function (para) { essay.appendChild(api.richEl('p', null, para)); });
            host.appendChild(essay);
            var words = (t.essay || []).join(' ').split(/\s+/).filter(function (w) { return /[А-Яа-яЁёA-Za-z0-9]/.test(w); }).length;
            host.appendChild(api.el('p', 'crs-hint', api.tt('essay_words', { n: words })));
            var mine = {};
            var table = api.el('div', 'rx-crit');
            var rows = {};
            crit.forEach(function (c) {
                var ct = (t.criteria && t.criteria[c.id]) || {};
                var row = api.el('div', 'rx-crit-row');
                var name = api.el('div', 'rx-crit-name');
                name.appendChild(api.el('b', null, c.id));
                name.appendChild(document.createTextNode(' ' + (ct.name || '')));
                row.appendChild(name);
                var seg = api.el('div', 'rx-seg');
                seg.setAttribute('role', 'radiogroup');
                seg.setAttribute('aria-label', c.id + ' ' + (ct.name || ''));
                var bs = [];
                for (var v = 0; v <= c.max; v++) {
                    (function (val) {
                        var b = api.el('button', 'rx-seg-b', String(val));
                        b.type = 'button';
                        b.setAttribute('role', 'radio');
                        b.setAttribute('aria-checked', 'false');
                        b.addEventListener('click', function () {
                            if (b.disabled) return;
                            mine[c.id] = val;
                            bs.forEach(function (x) { x.classList.remove('is-sel'); x.setAttribute('aria-checked', 'false'); });
                            b.classList.add('is-sel');
                            b.setAttribute('aria-checked', 'true');
                            api.primaryEnabled(crit.every(function (cc) { return mine.hasOwnProperty(cc.id); }));
                        });
                        bs.push(b);
                        seg.appendChild(b);
                    })(v);
                }
                row.appendChild(seg);
                var why = api.el('p', 'rx-why');
                why.hidden = true;
                row.appendChild(why);
                table.appendChild(row);
                rows[c.id] = { row: row, bs: bs, why: why };
            });
            host.appendChild(table);
            api.primary(api.t('check'), function () {
                var same = 0, sumMine = 0, sumExp = 0, maxSum = 0;
                crit.forEach(function (c) {
                    var r = rows[c.id], e = +expert[c.id], m = mine[c.id];
                    sumMine += m; sumExp += e; maxSum += c.max;
                    var ok = m === e;
                    if (ok) same++;
                    r.bs.forEach(function (b, v) { b.disabled = true; if (v === e) b.classList.add('is-right'); else if (v === m) b.classList.add('is-wrong'); });
                    r.row.classList.add(ok ? 'is-right' : 'is-wrong');
                    var w = t.why && t.why[c.id];
                    r.why.innerHTML = api.rich(api.tt('essay_expert', { n: e }) + (w ? ' — ' + w : ''));
                    r.why.hidden = false;
                });
                var score = crit.length ? same / crit.length : 1;
                api.answer({ correct: score >= (step.pass || 0.7) - 1e-9, score: score,
                    explain: api.tt('essay_total', { mine: sumMine, expert: sumExp, max: maxSum }) + (t.explain ? '\n\n' + t.explain : '') });
            }, true);
        }
    });

    /* ── пробная часть на время ───────────────────────────────────────── */
    function scoreTask(task, raw) {
        var max = task.max || 1;
        if (task.kind === 'word') {
            var g = normWord(raw);
            var ok = !!g && (task.accept || []).some(function (a) { return normWord(a) === g; });
            return ok ? max : 0;
        }
        if (task.kind === 'match' || task.kind === 'seq') {
            var gd = digitsOf(raw), key = String(task.key);
            if (gd === key) return max;
            /* задания 8 и 22 ЕГЭ: 1 балл, если не те символы на одной-двух
               позициях; символов больше, чем нужно, — 0 (система оценивания) */
            if (task.kind === 'match' && max === 2 && gd.length && gd.length <= key.length) {
                var diff = 0;
                for (var i = 0; i < key.length; i++) if (gd[i] !== key[i]) diff++;
                return diff <= 2 ? 1 : 0;
            }
            return 0;
        }
        /* set: порядок цифр значения не имеет (ФИПИ), лишняя цифра — ошибка */
        var dg = digitsOf(raw);
        if (!dg) return 0;
        return (dg.length === String(task.key).length && sortedSet(dg) === sortedSet(task.key) && sortedSet(dg).length === dg.length) ? max : 0;
    }

    K.step('mock-part', {
        graded: true,
        reviewable: false,
        mount: function (host, step, api) {
            var t = T(step);
            var tasks = step.tasks || [];
            var texts = t.tasks || [];
            if (t.prompt) host.appendChild(api.richEl('p', 'crs-prompt', t.prompt));
            if (t.text) {
                var src = api.el('details', 'rx-src');
                src.open = true;
                src.appendChild(api.el('summary', null, api.tt('mock_source')));
                (Array.isArray(t.text) ? t.text : [t.text]).forEach(function (para) { src.appendChild(api.richEl('p', null, para)); });
                host.appendChild(src);
            }
            var timer = null, left = step.seconds || 0, iv = null, done = false;
            if (left) {
                timer = api.el('p', 'rx-timer');
                timer.setAttribute('role', 'timer');
                host.appendChild(timer);
                var tick = function () {
                    var s = Math.max(0, Math.ceil(left));
                    timer.textContent = api.tt('mock_time_left', { t: Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2) });
                };
                tick();
                iv = setInterval(function () {
                    left -= 1;
                    tick();
                    if (left <= 0) { clearInterval(iv); iv = null; api.announce(api.tt('mock_time_up')); submit(true); }
                }, 1000);
                api.onCleanup(function () { if (iv) clearInterval(iv); });
            }
            var cards = tasks.map(function (task, i) {
                var tx = texts[i] || {};
                var card = api.el('section', 'rx-task');
                card.appendChild(api.el('p', 'rx-task-n', api.tt('mock_task', { n: task.n })));
                if (tx.q) {
                    String(tx.q).split('\n').forEach(function (line) { card.appendChild(api.richEl('p', 'rx-task-q', line)); });
                }
                var lab = api.el('label', 'rx-task-a');
                lab.appendChild(api.el('span', null, api.tt('mock_answer')));
                var inp = api.el('input', 'lg-input');
                inp.type = 'text';
                inp.autocomplete = 'off';
                inp.spellcheck = false;
                inp.setAttribute('autocapitalize', 'off');
                if (task.kind !== 'word') inp.inputMode = 'numeric';
                lab.appendChild(inp);
                card.appendChild(lab);
                var res = api.el('p', 'rx-why');
                res.hidden = true;
                card.appendChild(res);
                host.appendChild(card);
                return { card: card, inp: inp, res: res };
            });
            function submit(byTimer) {
                if (done) return;
                done = true;
                if (iv) { clearInterval(iv); iv = null; }
                var pts = 0, max = 0;
                tasks.forEach(function (task, i) {
                    var c = cards[i], got = scoreTask(task, c.inp.value), m = task.max || 1;
                    pts += got; max += m;
                    c.inp.disabled = true;
                    c.card.classList.add(got === m ? 'is-right' : got > 0 ? 'is-part' : 'is-wrong');
                    var key = task.kind === 'word' ? (task.accept || [])[0] : task.key;
                    var w = texts[i] && texts[i].why;
                    c.res.innerHTML = api.rich(api.tt('mock_points', { n: got, max: m }) + ' · ' + api.tt('mock_key', { key: key }) + (w ? '\n' + w : ''));
                    c.res.hidden = false;
                });
                api.answer({ correct: max ? pts / max >= (step.pass || 0.7) - 1e-9 : true, score: max ? pts / max : 1,
                    explain: (byTimer ? api.tt('mock_time_up') + ' ' : '') + api.tt('mock_total', { n: pts, max: max }) + (t.explain ? '\n\n' + t.explain : '') });
            }
            api.primary(api.tt('mock_submit'), function () { submit(false); });
        }
    });

    /* для node-теста: чистые функции оценки */
    K.ruExam = { normWord: normWord, scoreTask: scoreTask, sortedSet: sortedSet };
})();
